(function () {
  const viewTransitionRenderBlocker = document.getElementById(
    'view-transition-render-blocker'
  );

  /*
   * Remove the render blocker for reduced-motion users,
   * low-power devices and Meta in-app browsers.
   */
  if (
    (typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches) ||
    isLowPowerDevice() ||
    isEmbeddedInAppBrowser() ||
    typeof window.ViewTransition === 'undefined'
  ) {
    viewTransitionRenderBlocker?.remove();
  } else {
    /*
     * If the main content has not appeared quickly,
     * remove the blocker before 1.8 seconds.
     */
    const RENDER_BLOCKER_TIMEOUT_MS = Math.max(
      0,
      1800 - performance.now()
    );

    setTimeout(() => {
      viewTransitionRenderBlocker?.remove();
    }, RENDER_BLOCKER_TIMEOUT_MS);
  }

  const idleCallback =
    typeof requestIdleCallback === 'function'
      ? requestIdleCallback
      : setTimeout;

  window.addEventListener('pageswap', async (event) => {
    const { viewTransition } = /** @type {PageSwapEvent} */ (event);

    if (shouldSkipViewTransition(viewTransition)) {
      if (typeof viewTransition?.skipTransition === 'function') {
        viewTransition.skipTransition();
      }
      return;
    }

    /*
     * Cancel the transition after user interaction
     * to improve Interaction to Next Paint.
     */
    ['pointerdown', 'keydown'].forEach((eventName) => {
      document.addEventListener(
        eventName,
        () => {
          viewTransition.skipTransition();
        },
        { once: true }
      );
    });

    /*
     * Remove untriggered transition types to avoid
     * duplicated product-media transitions.
     */
    document
      .querySelectorAll(
        '[data-view-transition-type]:not([data-view-transition-triggered])'
      )
      .forEach((element) => {
        element.removeAttribute('data-view-transition-type');
      });

    const transitionTriggered = document.querySelector(
      '[data-view-transition-triggered]'
    );

    const transitionType =
      transitionTriggered?.getAttribute(
        'data-view-transition-type'
      );

    if (transitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(transitionType);

      safeSessionStorage('set', 'custom-transition-type', transitionType);
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');

      safeSessionStorage('remove', 'custom-transition-type');
    }
  });

  window.addEventListener('pagereveal', async (event) => {
    const { viewTransition } = /** @type {PageRevealEvent} */ (event);

    if (shouldSkipViewTransition(viewTransition)) {
      if (typeof viewTransition?.skipTransition === 'function') {
        viewTransition.skipTransition();
      }
      return;
    }

    const customTransitionType = safeSessionStorage('get', 'custom-transition-type');

    if (customTransitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(
        customTransitionType
      );

      // A cancelled navigation can reject finished in some WebViews.
      try {
        await viewTransition.finished;
      } catch (_) {
        // Cleanup is still necessary after a cancelled transition.
      }

      viewTransition.types.clear();
      viewTransition.types.add(
        'page-navigation'
      );

      idleCallback(() => {
        safeSessionStorage('remove', 'custom-transition-type');

        document
          .querySelectorAll(
            '[data-view-transition-type]'
          )
          .forEach((element) => {
            element.removeAttribute(
              'data-view-transition-type'
            );
          });
      });
    } else {
      viewTransition.types.clear();
      viewTransition.types.add(
        'page-navigation'
      );
    }
  });

  /**
   * Feature-detect the instance rather than referencing ViewTransition as
   * a global constructor: embedded browsers may not expose that constructor.
   * Transition types are required by this theme's existing animation logic.
   */
  function shouldSkipViewTransition(viewTransition) {
    return (
      !viewTransition ||
      typeof viewTransition.skipTransition !== 'function' ||
      !viewTransition.types ||
      typeof viewTransition.types.clear !== 'function' ||
      typeof viewTransition.types.add !== 'function' ||
      isLowPowerDevice() ||
      isEmbeddedInAppBrowser()
    );
  }

  function isEmbeddedInAppBrowser() {
    // Skip decorative transitions only. Links and checkout stay unchanged.
    return /FBAN|FBAV|Instagram|WhatsApp|MicroMessenger|Line\/|;\s*wv[;)]/i.test(
      navigator.userAgent || ''
    );
  }

  // Some WebViews reject storage calls even when sessionStorage is present.
  function safeSessionStorage(action, key, value) {
    try {
      if (action === 'get') return window.sessionStorage.getItem(key);
      if (action === 'set') window.sessionStorage.setItem(key, value);
      if (action === 'remove') window.sessionStorage.removeItem(key);
    } catch (_) {
      // Storage is optional: navigation must never depend on it.
    }
    return null;
  }

  /*
   * This logic is also used by the theme utilities.
   */
  function isLowPowerDevice() {
    return (
      Number(navigator.hardwareConcurrency) <= 2 ||
      Number(navigator.deviceMemory) <= 2
    );
  }
})();